import React from 'react'
import { remCalc, makeInitials, randomColor } from 'utils'

export interface SimpleProps {
  maxInitials?: number
  name?: string
  imageUrl?: string
  color?: string
  size?: number
  border?: boolean
  className?: string
}

const CONTAINER_STYLES = 'bg-cover p-0 mb-auto flex flex-shrink-0 rounded-full'
const BORDER_STYLES = 'border-2 border-body'

export const Simple: React.FC<SimpleProps> = ({
  name,
  color,
  imageUrl,
  border = false,
  maxInitials = 1,
  size = 48,
  className = '',
}) => {
  const circleStyles = {
    backgroundColor: color ? color : randomColor(),
    backgroundImage: imageUrl ? `url(${imageUrl})` : 'none',
    height: size,
    width: size,
    flexBasis: remCalc(size),
  }

  const initialsStyles = {
    fontSize: remCalc(size / 2),
  }

  return (
    <div
      className={[
        CONTAINER_STYLES,
        border ? BORDER_STYLES : null,
        className,
      ].join(' ')}
      style={circleStyles}
    >
      {name && !imageUrl ? (
        <div
          className="m-auto uppercase flex font-heading text-white"
          style={initialsStyles}
        >
          {makeInitials(name, maxInitials)}
        </div>
      ) : null}
    </div>
  )
}
